import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./assets/css/style.css"
import "./assets/css/FontAwesome/Css/all.min.css"
import "./assets/css/FontAwesome/Css/fontawesome.min.css"
import "cropperjs/dist/cropper.css";
import 'cropperjs/dist/cropper.min.css';
import AppRouter from './router/Route';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Header from './components/Header';
import registerDevice from './services/deviceService';

function App() {

  useEffect(() => {
    registerDevice().catch(() => {});
  }, []);

  const location = useLocation();
  const authRoutes = [
    "/",
    "/login",
    "/forgot-password",
    "/forgot-otp",
    "/reset-pass",
    "/select-project"
  ];

  const hideHeader = authRoutes.includes(location.pathname);

  return (
    <>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
      {!hideHeader && <Header />}
      <div className={`${!hideHeader ? "main-wrapper" : ""}`}>
        <AppRouter />
      </div>
    </>
  );
}

export default App;
